import React, { FC, useState } from 'react';
import LineCheckV3 from './LineCheckV3';
import GenericModal from './GenericModal';

const LincheckModal: FC<any> = ({
  content,
  onSuccess,
  showModal,
  setShowModal,
  productName,
  editClick,
  productId
}) => {
  const lincheckContent = content?.reference?.content?.body?.[0];
  const handleClick = () => {
    setShowModal(false);
  };

  return (
    <GenericModal
      modalState={showModal}
      handler={handleClick}
      showFooter={false}
      noCloseButton={true}
      backgroundColor='transparent'
      fixedWidth='850px'
    >
      <LineCheckV3
        content={lincheckContent}
        onSuccess={onSuccess}
        productName={productName}
        handleModalClick={handleClick}
        setShowModal={setShowModal}
        editClick = {editClick}
        productId={productId}
      />
    </GenericModal>
  );
};

export default LincheckModal;
